<ng-container *ngIf="isModal; else priceCard">
  <app-swipe-up
    [height]="95"
    [showHeader]="false"
    [showFooter]="true"
    [showSwipeUp]="showSwipeUp"
    (toggleShowSwipeUp)="toggleShowSwipeUp.emit();">
    <ng-container content>
      <ng-template *ngTemplateOutlet="priceCard"></ng-template>
    </ng-container>
    <ng-container footer>
      <div class="paymentDetailCont__buttonCont">
        <app-ds-button
          [labels]="{ ButtonLabel: 'BOOKING_MODULE.PAYMENT_DETAIL.ACCEPT' | transloco }"
          (clickEvent)="toggleShowSwipeUp.emit()">
        </app-ds-button>
      </div>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #priceCard>
  <ng-container *ngIf="!isModal">
    <div class="paymentDetailCont__sectionInfo" *ngIf="showInfo">
      <div class="paymentDetailCont__sectionInfo-title">
        <app-ds-typography
          [text]="'BOOKING_MODULE.PAYMENT_DETAIL.TITLE' | transloco"
          [fontFamily]="fontFamily.SemiBold"
          [tag]="'h2'"
          [color]="fontColor.Primary"
          [size]="isUserHistory ? fontSize.RG : fontSize.XS">
        </app-ds-typography>
      </div>
      <div class="paymentDetailCont__sectionInfo-subtitle">
        <app-ds-typography
          [text]="'USER_HISTORY_MODULE.PAYMENT_DETAIL.DESCRIPTION' | transloco"
          [tag]="'h3'"
          [color]="fontColor.Secondary"
          [size]="fontSize.XXS">
        </app-ds-typography>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!isLoading; else loading">
    <div class="paymentDetailCont__cardContent paymentDetailCont__cardContent--{{priceDetailCardType}}">
      <app-ds-price-detail-card
        [type]="priceDetailCardType"
        [title]="customTitle ? customTitle : isModal ? ('BOOKING_MODULE.PAYMENT_DETAIL.TITLE' | transloco) : ('BOOKING_MODULE.PAYMENT_DETAIL.TITLE_BOOKING' | transloco)"
        [subtitles]="subtitles"
        [rows]="rows"
        [discount]="discount"
        [total]="{
          Label: !applyConversion ? ('BOOKING_MODULE.PAYMENT_DETAIL.TOTAL' | transloco) : ('BOOKING_MODULE.PAYMENT_DETAIL.REFERENCE_PRICE' | transloco),
          Amount: total | currencyFormat: currencyCode,
          Info: text ?? ''
        }"
        [subtotal]="applyConversion ? {
          Label: 'BOOKING_MODULE.PAYMENT_DETAIL.TOTAL_IN' | transloco : { money: currencyExchangeName },
          Amount: total | exchangeCurrency: conversionRate,
        } : null"
        (closeEvent)="toggleShowSwipeUp.emit();">
      </app-ds-price-detail-card>
      <ng-container *ngIf="!isMobile">
        <div class="paymentDetailCont__body-cashback">
          <ng-content select="[cashbackContent]"></ng-content>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #loading>
  <app-payment-detail-loading></app-payment-detail-loading>
</ng-template>
